
export const handleAccordionTab = (value,key ,flag) => {
    return(dispatch) => {
        dispatch({
            type:"handleAccordionTab",
            value:value,
            key:key,
            flag,flag
            
        })
    }
}

export const handleGalleyShow = (value) => {
    return(dispatch) => {
        dispatch({
            type:"handleGalleyShow",
            value: value
        })
    }
}

export function handleTabsClick(key)
{
    return(dispatch)=>{
        dispatch({
            type: 'handleTabsClick',
            key:key,
        })
    }
}